import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { drw, errText } from "./api";

const SWITCHES = [
  ["auto_group_on_upload", "Auto-group on upload", "DRW-7 — apply the page grouping without the preview when a set is ingested."],
  ["auto_assign_high", "Auto-assign high-confidence room suggestions", "TKO-2 — pre-accept rows the system is sure of (inside a Bluebeam Space). They are still shown."],
  ["email_change_summaries", "Email takeoff change summaries", "TKO-2 — offer Send to PM / PE / Foreman after a takeoff session. Review before send; nothing automatic."],
  ["surface_change_items", "Surface change items in Change Orders", "TKO-3 — list ASI / field-change marks under the project's Change Orders tab."],
];

/** Settings › Ops — the takeoff switches. All default OFF. */
export default function TakeoffSettings() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { drw.get("/takeoff-settings").then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  const flip = async (k, v) => {
    try { const { data } = await drw.put("/takeoff-settings", { [k]: v }); setCfg(data); toast.success("Saved"); }
    catch (e) { toast.error(errText(e)); }
  };
  if (!cfg) return null;
  return (
    <section className="rounded-xl border p-4 space-y-3 bg-white" data-testid="takeoff-settings">
      <div>
        <div className="font-semibold">Drawings — takeoff editing</div>
        <div className="text-xs text-neutral-500">Who may edit is the access matrix (admin, PM, project engineer, foreman); these only switch behaviour.</div>
      </div>
      {SWITCHES.map(([k, label, help]) => (
        <label key={k} className="flex items-start gap-3 text-sm">
          <input type="checkbox" checked={!!cfg[k]} disabled={!cfg.can_edit} onChange={(e) => flip(k, e.target.checked)} className="mt-1" data-testid={`takeoff-setting-${k}`} />
          <span><span className="font-medium">{label}</span><span className="block text-xs text-neutral-500">{help}</span></span>
        </label>
      ))}
    </section>
  );
}
